import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "gfu-project-summary-pledge" }
const _hoisted_2 = { class: "gfu-1of1" }
const _hoisted_3 = { class: "_ml-1" }
const _hoisted_4 = {
  class: "gfu-project-summary-box__title",
  "data-qa": "project-summary-box:TotalFundedAmount"
}
const _hoisted_5 = { class: "gfu-hd gfu-hd--h4" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 2,
  class: "gfu-project-summary-action"
}
const _hoisted_8 = {
  key: 4,
  class: "gfu-project-summary-action"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "gfu-btn__text" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "gfu-btn__text" }
const _hoisted_13 = {
  class: "_pt-2 _tac",
  "data-qa": "project-summary:ViewCampaignSummary"
}
const _hoisted_14 = {
  key: 1,
  class: "_flexcol _gap-3 _mb-9"
}
const _hoisted_15 = { class: "gfu-project-summary-pledge" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_project_summary_box_header = _resolveComponent("project-summary-box-header")
  const _component_display_currency_value = _resolveComponent("display-currency-value")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_project_summary_clock = _resolveComponent("project-summary-clock")
  const _component_project_summary_backer = _resolveComponent("project-summary-backer")
  const _component_project_summary_credits = _resolveComponent("project-summary-credits")
  const _component_back_project_button = _resolveComponent("back-project-button")
  const _component_project_summary_follow = _resolveComponent("project-summary-follow")
  const _component_skeleton_button = _resolveComponent("skeleton-button")
  const _component_project_summary_box = _resolveComponent("project-summary-box")
  const _component_project_summary_completed = _resolveComponent("project-summary-completed")
  const _component_project_summary_card = _resolveComponent("project-summary-card")

  return (_openBlock(), _createBlock(_component_project_summary_card, { "is-flipped": _ctx.isCardFlipped }, _createSlots({
    front: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_project_summary_box, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!$options.countdownDate)
                ? (_openBlock(), _createBlock(_component_base_icon, {
                    key: 0,
                    name: "brand-outline",
                    "icon-namespace": "ga",
                    size: "2x",
                    class: "_tc--accent"
                  }))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_project_summary_box_header, {
                layout: $options.projectSummaryHeaderLayout,
                "data-qa": $options.projectSummaryHeaderDataQa
              }, _createSlots({
                header: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.projectSummaryHeader), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, [
                ($options.isProjectInPledgeManagerPhases && $options.subHeaderContent)
                  ? {
                      name: "subheader",
                      fn: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass($options.subHeaderContent.emphasisClass)
                        }, _toDisplayString($options.subHeaderContent.emphasis), 3 /* TEXT, CLASS */),
                        _createElementVNode("span", _hoisted_3, _toDisplayString($options.subHeaderContent.text), 1 /* TEXT */)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["layout", "data-qa"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["_tac", { '_my-2': $options.countdownDate }])
            }, [
              _createElementVNode("h3", _hoisted_4, [
                _createVNode(_component_display_currency_value, {
                  "display-tooltip": false,
                  tag: "span"
                }, {
                  content: _withCtx(({ displayCurrency }) => [
                    _createTextVNode(_toDisplayString(_ctx.$format($options.fundsGatheredConverted / displayCurrency.relativeFactor, 'C0', displayCurrency.symbol)), 1 /* TEXT */)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$format($options.fundsGatheredConverted, 'C0')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("h4", _hoisted_5, [
                  _createTextVNode(_toDisplayString($options.backersCountConverted) + " ", 1 /* TEXT */),
                  _createVNode(_component_tooltip, null, {
                    content: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.fundsGatheredTooltipInfo), 1 /* TEXT */)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_base_icon, { name: "circle-info" })
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ])
            ], 2 /* CLASS */),
            ($options.countdownDate)
              ? (_openBlock(), _createBlock(_component_project_summary_clock, {
                  key: 0,
                  class: "_mt-1",
                  "elapsed-message": _ctx.Resources.ProjectHome.ProjectSummaryClockElapsedMessage,
                  "target-date": $options.countdownDate,
                  title: _ctx.Resources.ProjectHome.ProjectSummaryBoxPledgeManagerCountdownTitle
                }, null, 8 /* PROPS */, ["elapsed-message", "target-date", "title"]))
              : _createCommentVNode("v-if", true)
          ]),
          actions: _withCtx(() => [
            (_ctx.isCartSummaryLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  ($options.showBackerInfo)
                    ? (_openBlock(), _createBlock(_component_project_summary_backer, {
                        key: 0,
                        number: $props.backerNumber,
                        href: $props.backProjectUrl
                      }, null, 8 /* PROPS */, ["number", "href"]))
                    : _createCommentVNode("v-if", true),
                  ($options.isCreditBalancePositive && $options.isPledgeAvailable)
                    ? (_openBlock(), _createBlock(_component_project_summary_credits, {
                        key: 1,
                        "credit-balance": $props.creditBalance,
                        href: $props.backProjectUrl
                      }, null, 8 /* PROPS */, ["credit-balance", "href"]))
                    : _createCommentVNode("v-if", true),
                  ($options.isBackProjectButtonVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_back_project_button)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (!$options.showBackerInfo)
                    ? (_openBlock(), _createBlock(_component_project_summary_follow, { key: 3 }))
                    : _createCommentVNode("v-if", true),
                  ($options.canUpgradePledge || _ctx.isPledgeImplicitEditMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (!$options.isProjectShippingOnly)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: $props.backProjectUrl,
                              class: "gfu-btn gfu-btn--primary gfu-btn--soft gfu-btn--block _px-3 gfu-btn--wide _mb-2",
                              "data-qa": "project-summary:UpgradePldge"
                            }, [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryBoxUpgradePledgeButton), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_9))
                          : _createCommentVNode("v-if", true),
                        (_ctx.isProjectInPledgeManagerPhase)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: _ctx.currentPledge.manageShippingUrl,
                              class: "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--block _px-3 gfu-btn--wide",
                              "data-qa": "project-summary:CompletePledge"
                            }, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryBoxCompletePledgeButton), 1 /* TEXT */)
                            ], 8 /* PROPS */, _hoisted_11))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "gfu-link gfu-link--accent",
                      onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.toggleCard && $options.toggleCard(...args)), ["prevent"]))
                    }, _toDisplayString(_ctx.Resources.ProjectHome.ProjectSummaryBoxCrowdfundingSummaryButton), 1 /* TEXT */)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                    return _createVNode(_component_skeleton_button, {
                      key: n,
                      class: "_grow-1"
                    })
                  }), 64 /* STABLE_FRAGMENT */))
                ]))
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.isCardFlipped)
      ? {
          name: "back",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("a", {
                href: "#",
                class: "gfu-project-summary-pledge__close",
                onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.toggleCard && $options.toggleCard(...args)), ["prevent"]))
              }, [
                _createTextVNode(_toDisplayString(_ctx.Resources.Layout.CloseButton) + " ", 1 /* TEXT */),
                _createVNode(_component_base_icon, {
                  name: "times",
                  size: "lg",
                  class: "_ml-1 _fr"
                })
              ]),
              _createVNode(_component_project_summary_completed)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-flipped"]))
}